export default __webpack_public_path__ + "static/media/investment_inactive.ea477a33.svg";